/**
 * Capitalizes the first letter of the input string.
 *
 * @param {string} string - the input string
 * @return {string} the input string with the first letter capitalized
 * @example toUpperCaseFirstLetter('hello') // 'Hello'
 *  toUpperCaseFirstLetter('WORLD') // 'World'
 *  toUpperCaseFirstLetter('e-CHAT') // 'E-chat'
 */
export function toUpperCaseFirstLetter(string) {
    const lowercaseString = string.toLowerCase();
  return string.charAt(0).toUpperCase() + lowercaseString.slice(1);
}
